/* ==========================================================================
   PixelMob in Action — 播放器 + 滑轨 + 浮动按钮交互
   ========================================================================== */
(function () {
  var root = document.querySelector('[data-pm-ia]');
  if (!root) return;

  var modal = root.querySelector('[data-pm-ia-modal]');
  var modalMedia = root.querySelector('[data-pm-ia-modal-media]');
  var modalCreator = root.querySelector('[data-pm-ia-modal-creator]');
  var modalTitle = root.querySelector('[data-pm-ia-modal-title]');
  var closeButtons = root.querySelectorAll('[data-pm-ia-close]');

  var lastFocused = null;
  var activeVideo = null;

  /* ---------- 工具 ---------- */
  function extractYouTubeId(url) {
    var m = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})(?:[?&#/]|$)/
    );
    return m ? m[1] : null;
  }

  function hydrateYouTubeThumbnail(card, trigger) {
    var id = extractYouTubeId(trigger.getAttribute('data-video-url') || '');
    var media = trigger.closest('.pm-ia-card__media');
    if (!id || !media || media.querySelector('.pm-ia-media__img')) return;

    var placeholder = media.querySelector('.pm-ia-media__ph');
    if (placeholder) placeholder.remove();

    var image = document.createElement('img');
    image.className = 'pm-ia-media__img';
    image.alt = trigger.getAttribute('data-title') || '';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.src = 'https://i.ytimg.com/vi/' + id + '/sddefault.jpg';
    image.addEventListener('error', function () {
      if (image.dataset.fallbackTried) {
        image.remove();
        return;
      }
      image.dataset.fallbackTried = 'true';
      image.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    });
    media.insertBefore(image, media.firstChild);

    var play = document.createElement('span');
    play.className = 'pm-ia-media__play';
    play.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="6" width="18" height="12" rx="4" fill="white"/><path d="M10 9.3v5.4l4.7-2.7L10 9.3Z" fill="#ff0033"/></svg>';
    media.appendChild(play);
  }

  function clearMedia() {
    if (activeVideo) {
      try {
        activeVideo.pause();
      } catch (e) {}
      if (activeVideo.tagName === 'VIDEO') {
        activeVideo.removeAttribute('src');
        activeVideo.load();
      }
      activeVideo = null;
    }
    modalMedia.innerHTML = '';
  }

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    clearMedia();
    if (lastFocused) {
      lastFocused.focus();
      lastFocused = null;
    }
  }

  function openVideo(trigger) {
    var type = trigger.getAttribute('data-video-type');
    var title = trigger.getAttribute('data-title') || '';
    var creator = trigger.getAttribute('data-creator') || '';

    // Instagram：直接打开原帖，不进入弹层
    if (type === 'instagram') {
      var ig = trigger.getAttribute('data-instagram-url');
      if (ig) {
        window.open(ig, '_blank', 'noopener');
      }
      return;
    }

    if (type !== 'youtube' && type !== 'shopify') return;

    if (type === 'youtube' && trigger.hasAttribute('data-video-external')) {
      var youtubeUrl = trigger.getAttribute('data-video-url');
      if (youtubeUrl) window.open(youtubeUrl, '_blank', 'noopener');
      return;
    }

    clearMedia();

    // portrait modal only for vertical Shopify-hosted clips;
    // YouTube sources always play in the standard 16:9 player
    var isPortrait = type === 'shopify' &&
      (trigger.classList.contains('pm-ia-media--9x16') ||
        !!trigger.closest('.pm-ia-media--9x16'));
    if (modalMedia) modalMedia.classList.toggle('is-portrait', isPortrait);

    if (type === 'youtube') {
      var ytId = extractYouTubeId(trigger.getAttribute('data-video-url') || '');
      if (!ytId) {
        var youtubeUrl = trigger.getAttribute('data-video-url');
        if (youtubeUrl) window.open(youtubeUrl, '_blank', 'noopener');
        return;
      }
      var iframe = document.createElement('iframe');
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.src = 'https://www.youtube.com/embed/' + ytId +
        '?autoplay=1&rel=0&playsinline=1&enablejsapi=1&origin=' +
        encodeURIComponent(window.location.origin) + '&widget_referrer=' +
        encodeURIComponent(window.location.href);
      iframe.title = title;
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      modalMedia.appendChild(iframe);
    } else if (type === 'shopify') {
      var src = trigger.getAttribute('data-video-src') || '';
      if (src) {
        var video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';
        modalMedia.appendChild(video);
        activeVideo = video;
      }
    }

    if (modalCreator) modalCreator.textContent = creator;
    modalTitle.textContent = title;
    openModal();
  }

  /* ---------- 事件绑定 ---------- */
  /* Smooth in-page anchors for the hero CTAs */
  root.querySelectorAll('[data-pm-ia-scroll]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  root.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pm-ia-open]');
    if (trigger) {
      e.preventDefault();
      lastFocused = trigger;
      openVideo(trigger);
    }
  });

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  /* ---------- Quick Takes 滑轨箭头 ---------- */
  var takesTrack = root.querySelector('[data-pm-ia-takes-track]');
  if (takesTrack) {
    var prev = root.querySelector('[data-pm-ia-takes-prev]');
    var next = root.querySelector('[data-pm-ia-takes-next]');

    function step() {
      var card = takesTrack.querySelector('.pm-ia-card--take');
      return card ? card.getBoundingClientRect().width + 20 : 300;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        takesTrack.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        takesTrack.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
  }

  /* ---------- Creator reviews: horizontal scroll arrows ---------- */
  var reviewsWrap = root.querySelector('[data-pm-ia-reviews]');
  var reviewsTrack = root.querySelector('[data-pm-ia-reviews-track]');
  if (reviewsWrap && reviewsTrack) {
    var revPrev = root.querySelector('[data-pm-ia-reviews-prev]');
    var revNext = root.querySelector('[data-pm-ia-reviews-next]');
    function revStep() {
      var card = reviewsTrack.querySelector('.pm-ia-card--review');
      return card ? card.getBoundingClientRect().width + 24 : 320;
    }
    if (revPrev) {
      revPrev.addEventListener('click', function () {
        reviewsTrack.scrollBy({ left: -revStep(), behavior: 'smooth' });
      });
    }
    if (revNext) {
      revNext.addEventListener('click', function () {
        reviewsTrack.scrollBy({ left: revStep(), behavior: 'smooth' });
      });
    }
    function updateRevArrows() {
      var overflow = reviewsTrack.scrollWidth > reviewsTrack.clientWidth + 4;
      reviewsWrap.classList.toggle('is-scrollable', overflow);
    }
    updateRevArrows();
    window.addEventListener('resize', updateRevArrows);
    window.addEventListener('load', updateRevArrows);
  }

  /* ---------- Review cards: pull real YouTube title / channel name / avatar ---------- */
  function extractYoutubeHandle(url) {
    if (!url) return '';
    var m = url.match(/youtube\.com\/@([^\/?#]+)/) || url.match(/youtube\.com\/channel\/([^\/?#]+)/) ||
            url.match(/youtube\.com\/c\/([^\/?#]+)/) || url.match(/youtube\.com\/user\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  function ensureCreatorRow(card, name) {
    var row = card.querySelector('.pm-ia-card__creator');
    if (row) return row;
    var body = card.querySelector('.pm-ia-card__body');
    if (!body) return null;
    row = document.createElement('div');
    row.className = 'pm-ia-card__creator';
    var fb = document.createElement('span');
    fb.className = 'pm-ia-card__avatar-fallback';
    fb.textContent = (name || '?').slice(0, 1).toUpperCase();
    var nm = document.createElement('span');
    nm.className = 'pm-ia-card__creator-name';
    nm.textContent = name || '';
    row.appendChild(fb);
    row.appendChild(nm);
    var title = card.querySelector('.pm-ia-card__title');
    if (title) { title.parentNode.insertBefore(row, title); } else { body.insertBefore(row, body.firstChild); }
    return row;
  }

  function applyChannelAvatar(card, handle) {
    if (!handle) return;
    var row = card.querySelector('.pm-ia-card__creator');
    if (!row) return;
    var existing = row.querySelector('.pm-ia-card__avatar');
    var fb = row.querySelector('.pm-ia-card__avatar-fallback');
    if (existing) { existing.src = 'https://unavatar.io/youtube/' + handle; return; }
    var image = document.createElement('img');
    image.className = 'pm-ia-card__avatar';
    image.alt = '';
    image.loading = 'lazy';
    image.addEventListener('error', function () { image.remove(); if (fb) fb.style.display = ''; });
    image.src = 'https://unavatar.io/youtube/' + handle;
    row.insertBefore(image, row.firstChild);
    if (fb) fb.style.display = 'none';
  }

  /* ---------- Capability tabs (demo + creator stories) ---------- */
  function bindCapabilityTabs(tabAttr, panelAttr) {
    var tabs = root.querySelectorAll('[' + tabAttr + ']');
    if (!tabs.length) return;
    var panels = root.querySelectorAll('[' + panelAttr + ']');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute(tabAttr);
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute(panelAttr) === key);
        });
        window.dispatchEvent(new Event('resize'));
      });
    });
  }
  bindCapabilityTabs('data-pm-ia-demo-tab', 'data-pm-ia-demo-panel');
  bindCapabilityTabs('data-pm-ia-creator-tab', 'data-pm-ia-creator-panel');

  /* ---------- Mobile tab overflow hint ---------- */
  root.querySelectorAll('[data-pm-ia-creator-tabs], [data-pm-ia-demo-tabs]').forEach(function (tabs) {
    function updateTabHint() {
      var hasMore = tabs.scrollLeft + tabs.clientWidth < tabs.scrollWidth - 4;
      tabs.classList.toggle('has-more-tabs', hasMore);
    }
    tabs.addEventListener('scroll', updateTabHint, { passive: true });
    window.addEventListener('resize', updateTabHint);
    updateTabHint();
  });

  /* ---------- Creator stories: horizontal card carousel ---------- */
  var creatorNav = root.querySelector('[data-pm-ia-creator-nav]');
  var creatorPrev = root.querySelector('[data-pm-ia-creator-prev]');
  var creatorNext = root.querySelector('[data-pm-ia-creator-next]');
  function creatorScroller() {
    var panel = root.querySelector('[data-pm-ia-creator-panel].is-active');
    return panel || null;
  }
  function creatorStep() {
    var track = creatorScroller();
    var card = track && track.querySelector('.pm-ia-card');
    return card ? card.getBoundingClientRect().width + 20 : 320;
  }
  function updateCreatorNav() {
    var track = creatorScroller();
    var hasOverflow = !!track && track.scrollWidth > track.clientWidth + 4;
    if (creatorNav) creatorNav.classList.toggle('is-visible', hasOverflow);
    if (creatorPrev) creatorPrev.disabled = !hasOverflow;
    if (creatorNext) creatorNext.disabled = !hasOverflow;
  }
  if (creatorPrev) {
    creatorPrev.addEventListener('click', function () {
      var track = creatorScroller();
      if (track) track.scrollBy({ left: -creatorStep(), behavior: 'smooth' });
    });
  }
  if (creatorNext) {
    creatorNext.addEventListener('click', function () {
      var track = creatorScroller();
      if (track) track.scrollBy({ left: creatorStep(), behavior: 'smooth' });
    });
  }
  root.querySelectorAll('[data-pm-ia-creator-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () { window.requestAnimationFrame(updateCreatorNav); });
  });
  window.addEventListener('resize', updateCreatorNav);
  window.addEventListener('load', updateCreatorNav);
  updateCreatorNav();

  /* ---------- Feature demos: horizontal card carousel ---------- */
  var demoNav = root.querySelector('[data-pm-ia-demo-nav]');
  var demoPrev = root.querySelector('[data-pm-ia-demo-prev]');
  var demoNext = root.querySelector('[data-pm-ia-demo-next]');
  function demoScroller() {
    var panel = root.querySelector('[data-pm-ia-demo-panel].is-active');
    return panel ? panel.querySelector('.pm-ia-demos') : null;
  }
  function demoStep() {
    var track = demoScroller();
    var card = track && track.querySelector('.pm-ia-card');
    return card ? card.getBoundingClientRect().width + 20 : 320;
  }
  function updateDemoNav() {
    var track = demoScroller();
    var hasOverflow = !!track && track.scrollWidth > track.clientWidth + 4;
    if (demoNav) demoNav.classList.toggle('is-visible', hasOverflow);
    if (demoPrev) demoPrev.disabled = !hasOverflow;
    if (demoNext) demoNext.disabled = !hasOverflow;
  }
  if (demoPrev) {
    demoPrev.addEventListener('click', function () {
      var track = demoScroller();
      if (track) track.scrollBy({ left: -demoStep(), behavior: 'smooth' });
    });
  }
  if (demoNext) {
    demoNext.addEventListener('click', function () {
      var track = demoScroller();
      if (track) track.scrollBy({ left: demoStep(), behavior: 'smooth' });
    });
  }
  root.querySelectorAll('[data-pm-ia-demo-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () { window.requestAnimationFrame(updateDemoNav); });
  });
  window.addEventListener('resize', updateDemoNav);
  window.addEventListener('load', updateDemoNav);
  updateDemoNav();


  /* ---------- Generic horizontal rails (creators & demos) ---------- */
  root.querySelectorAll('[data-pm-ia-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-pm-ia-rail-track]');
    if (!track) return;
    var prev = rail.querySelector('[data-pm-ia-rail-prev]');
    var next = rail.querySelector('[data-pm-ia-rail-next]');

    function step() {
      var card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 20 : 320;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    function update() {
      rail.classList.toggle('is-scrollable', track.scrollWidth > track.clientWidth + 4);
    }
    update();
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
  });

  /* ---------- Lazy hydration: run only when a card nears the viewport ---------- */
  function hydrateCard(trigger) {
    var card = trigger.closest('.pm-ia-card');
    if (!card || card.dataset.hydrated) return;
    card.dataset.hydrated = '1';

    hydrateYouTubeThumbnail(card, trigger);

    var configuredHandle = trigger.getAttribute('data-creator-youtube-handle');
    if (configuredHandle) applyChannelAvatar(card, configuredHandle);

    var url = trigger.getAttribute('data-video-url');
    if (!url) return;
    fetch('https://noembed.com/embed?url=' + encodeURIComponent(url))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data) return;
        var isReview = card.classList.contains('pm-ia-card--review');
        if (isReview && data.title) {
          var titleEl = card.querySelector('.pm-ia-card__title');
          if (titleEl) titleEl.textContent = data.title;
        }
        if (isReview && data.author_name) {
          var row = ensureCreatorRow(card, data.author_name);
          if (row) {
            var nameEl = row.querySelector('.pm-ia-card__creator-name');
            if (nameEl) nameEl.textContent = data.author_name;
          }
        }
        var handle = extractYoutubeHandle(data.author_url);
        if (handle) applyChannelAvatar(card, handle);
      })
      .catch(function () {});
  }

  var lazyTriggers = root.querySelectorAll('[data-video-url]');
  if ('IntersectionObserver' in window) {
    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cardObserver.unobserve(entry.target);
        hydrateCard(entry.target);
      });
    }, { rootMargin: '400px 0px' });
    lazyTriggers.forEach(function (t) { cardObserver.observe(t); });
  } else {
    lazyTriggers.forEach(hydrateCard);
  }
})();
